import { useEffect, useState } from "react";
import { getOrganizationLookupInputFromHostname } from "@shared/utils/orgLoginRouting";
import {
  fetchPublicCompliancePosture,
  type PublicCompliancePosture,
} from "@shared/services/loginMarketingPostureClient";

export function usePublicCompliancePosture(): PublicCompliancePosture | null {
  const [posture, setPosture] = useState<PublicCompliancePosture | null>(null);

  useEffect(() => {
    const lookup = getOrganizationLookupInputFromHostname(
      window.location.hostname,
    );
    if (!lookup) {
      return;
    }

    let cancelled = false;
    void fetchPublicCompliancePosture(lookup).then((result) => {
      if (!cancelled) {
        setPosture(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return posture;
}
